import graphqlClient from "@/GQLClient";
import {
  type ResourceInput,
  SaveResourceDocument,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const save = async (resource: ResourceInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveResourceDocument,
    variables: {
      resource,
    },
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  });

  if (response.data?.resource?.save?.success) {
    return response.data.resource.save.id;
  }

  throw new SentryGraphQLError(`api.resource.save`, response);
};

export default {
  save,
};
